import AnalysisTypeEnum from '@/utilities/paperwork/enums/AnalysisTypeEnum'

export default {
  setAnalysis: (state, payload) => {
    state.container = payload
  },
  setAllOfBidNumber: (state, payload) => {
    state.all = payload
  },
  newAnalysis: (state, payload) => {
    if (state.container === null) {
      state.container = []
    }

    payload.forEach(item => {
      state.container.push(item)
    })
  },
  update: (state, payload) => {
    if (state.container !== null) {
      state.container = state.container.map(item => (item.id === payload.id ? payload : item))
    }
  },
  removeAnalysis: (state, payload) => {
    if (payload !== null) {
      const index = state.container.findIndex(item => {
        return parseInt(item.id) === parseInt(payload.id)
      })
      state.container.splice(index, 1)
    } else {
      state.container = null
    }
  },
  newPeriod: (state, payload) => {
    state.container.forEach(item => {
      if (parseInt(item.id) === parseInt(payload.id)) {
        switch (payload.type) {
          case 'capture':
            payload.period.forEach(element => {
              item.capturePeriod.push(element)
            })
            return null
          case 'analysis':
            payload.period.forEach(element => {
              item.analysisPeriod.push(element)
            })
            return null
          case 'window':
            payload.period.forEach(element => {
              item.windowPeriod.push(element)
            })
            return null
        }
      }
    })
  },
  removePeriod: (state, payload) => {
    let period = null
    const index = state.container.findIndex(item => {
      return parseInt(item.id) === parseInt(payload.period.analysis)
    })
    switch (payload.type) {
      case 'capture':
        period = state.container[index].capturePeriod
        break
      case 'analysis':
        period = state.container[index].analysisPeriod
        break
      case 'window':
        period = state.container[index].windowPeriod
        break
    }
    const periodIndex = period.findIndex(item => {
      return parseInt(item.id) === parseInt(payload.period.id)
    })

    period.splice(periodIndex, 1)
  },
  removeAllPeriods: (state, payload) => {
    state.container.forEach(item => {
      if (item.id !== payload.period.analysis) {
        return
      }

      switch (payload.type) {
        case AnalysisTypeEnum.CAPTURE:
          return (item.capturePeriod = [])
        case AnalysisTypeEnum.ANALYSIS:
          return (item.analysisPeriod = [])
        case AnalysisTypeEnum.WINDOW:
          return (item.windowPeriod = [])
      }
    })
  },
}
